// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function Content() {
  return (
    <MDBox>
      <MDBox width="82%" textAlign="center" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
        Public sentiment shapes the future of renewable energy adoption, influencing policies and projects nationwide. Using over 8 million X (Twitter) posts from 2013 to 2022, we measure "solar sentiment" ––public attitudes or perceptions toward solar energy–– in the United States. Use this interactive tool to explore solar sentiment in your community and how public perception of solar power has evolved over the past decade.
        </MDTypography>
      </MDBox>
      <MDBox mt={2}>
        <Grid container spacing={3}>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default Content;
